module.exports = __webpack_public_path__ + "7d259dad358bbb67f71273fe94c9dfd5.png";